'use strict';
import axios from 'axios';
import store from '../store';

export default class EmailStatus {
	static emailStatus(interaction) {
		if (process.env.NODE_ENV === 'development') {
			return this.developmentEmailStatus(interaction);
		}
		return axios.post(`../${store.getters.getConfig['email_status']}`, {
			interaction: interaction,
		});
	}

	static developmentEmailStatus(interaction) {
		return axios.post('/api/emailStatus', {
			interaction: interaction,
		});
	}
}
